const KEY = 'ph.chat.draft';

/** Tab-scoped input survives recovery reloads when storage is available. */
export function readDraft(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

/** Whether the tab storage accepted the write/removal; callers can defer reload. */
export function saveDraft(draft: string): boolean {
  try {
    if (draft) sessionStorage.setItem(KEY, draft);
    else sessionStorage.removeItem(KEY);
    return true;
  } catch {
    return false;
  }
}
